import { render, staticRenderFns } from "./CreateInstructorsPage.vue?vue&type=template&id=25e532f6&scoped=true"
import script from "./CreateInstructorsPage.vue?vue&type=script&lang=ts"
export * from "./CreateInstructorsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e532f6",
  null
  
)

export default component.exports